<template>
  <div>
    <v-progress-linear
      v-if="!result"
      indeterminate
      color="primary"
      height="6"
      rounded
    />
    {{ result }}
  </div>
</template>

<script>
import CategoriesRequest from 'Modules/contacard/faq/categories/CategoriesRequest';

export default {
  name: 'DataTableGetByIdRow',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {
          shouldWrap: false,
        };
      },
    },
  },
  data: () => ({
    result: '',
  }),
  computed: {
  },
  created() {
    this.getRequestvalue();
  },
  methods: {
    getRequestvalue() {
      CategoriesRequest.get(this.value)
        .then((data) => {
          this.result = data.data.name;
        });
    },
  },
};
</script>
